import { FaBars, FaPlus } from "react-icons/fa6";
import { Badge, Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import AddQueryParameterModal from "./AddQueryParameterModal";
import ManageQuery from "./ManageQuery";
import UpdateQueryParameterModal from "./UpdateQueryParameterModal";
import AddQueryDynamicValueModal from "./AddQueryDynamicValueModal";
import UpdateQueryDynamicValueModal from "./UpdateQueryDynamicValueModal";
import AddQueryCustomValueModal from "./AddQueryCustomValueModal";
import UpdateQueryCustomValueModal from "./UpdateQueryCustomValueModal";
import AddQueryOperatorModal from "./AddQueryOperatorModal";
import UpdateQueryOperatorModal from "./UpdateQueryOperatorModal";
import Swal from "sweetalert2";
import UseToggle from "../../../../Hooks/UseToggle";
import AddQueryFunctionModal from "./AddQueryFunctionModal";
import UpdateQueryFunctionModal from "./UpdateQueryFunctionModal";
import SplitPane from "react-split-pane";

const CustomEditCheckQuery = ({ checkData, getStudyLevelCustomEditCheck, type, miniOperator }) => {
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2, toggle3, setToggle3, toggle4, setToggle4, toggle5, setToggle5, toggle6, setToggle6, toggle7, setToggle7, toggle8, setToggle8, toggle9, setToggle9, toggle10, setToggle10 } = UseToggle();
  const [formMetadataList, setFormMetadataList] = useState([]);
  const [formFields, setFormFields] = useState([]);
  const [query, setQuery] = useState([]);
  const [options, setOptions] = useState("");
  const [checkType, setCheckType] = useState("");
  const [eventName, setEventName] = useState("");
  const [timePointLabel, setTimePointLabel] = useState("");
  const [eventId, setEventId] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [eventRows, setEventRows] = useState([]);
  const [formCode, setFormCode] = useState("");
  const [version, setVersion] = useState("");
  const [mainVersion, setMainVersion] = useState(0);
  const [formId, setFormId] = useState("");
  const [queryId, setQueryId] = useState("");
  const [fieldCode, setFieldCode] = useState("");
  const [mainFieldCode, setMainFieldCode] = useState("");
  const [customField, setCustomField] = useState("");
  const [customFieldData, setCustomFieldData] = useState("");
  const [fieldId, setFieldId] = useState("");
  const [fieldUnit, setFieldUnit] = useState("no");
  const [optionValue, setOptionValue] = useState("");
  const [customType, setCustomType] = useState("text");
  const [valueId, setValueId] = useState("");
  const [customValue, setCustomValue] = useState("");
  const [operator, setOperator] = useState("");
  const [functions, setFunctions] = useState("");
  let { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [buttonLoader, setButtonLoader] = useState(false);

  const getEventBasedonSchema = async (e) => {
    let data = await studyEventFormSchemaServices.getEventBasedonSchema(studyId, checkData?.schemaId, "all");
    setEventRows(data?.data || []);
    setFieldCode("")
    setFieldId("")
    setFormId("")
    setFormCode("")
    setVersion("")
    setMainVersion(0)
    setMainFieldCode("")
    setFormFields([])
  };

  const getSchemaEventForms = async (e) => {
    let data = await studyEventManagementServices.getSchemaEventForms(
      studyId,
      checkData?.schemaId,
      eventId,
      timePointId || "no", StudyMode
    );
    setFormMetadataList(data?.data || []);
    setFieldCode("")
    setFieldId("")
    setFormId("")
    setFormCode("")
    setVersion("")
    setMainVersion(0)
    setMainFieldCode("")
    setFormFields([])
  };
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudyLevelForm = async (e) => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      "active",
      StudyMode
    );
    setFormMetadataList(data?.data || []);
    let checkFormCode = (data?.data || [])?.find(item => item.formId === checkData?.formId)
    setFormCode(checkFormCode?.formCode)
    setMainVersion(checkFormCode?.version)
    setFieldCode("")
    setFieldId("")
    setVersion("")
    setMainFieldCode("")
    setFormFields([])
  };

  const getStudyLevelFormFieldsByVersion = async () => {
    setMainVersion(version)
    let data = await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
      studyId,
      formId,
      version
    );
    if (data === "AbortError") {
      setFormFields([]);
    } else {
      setFormFields(data?.data?.formFields || []);
    }
  };

  const updateGlobalCustomEditCheck = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update ${type === "fieldNotification" ? "Field Notification" : "Custom Edit"} Check Query!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = checkData?._id;
        userData.fieldCode = checkData?.fieldCode;
        userData.query = query
        userData.type = "query"
        userData.studyId = studyId
        let data;
        if (type === "fieldNotification") {
          data = await studyLevelFormManagementServices.updateStudyLevelFieldCheckNotification(userData);
        } else {
          data = await studyLevelFormManagementServices.updateStudyLevelCustomEditCheck(userData);
        }
        if (data?.statusCode === 200) {
          getStudyLevelCustomEditCheck()
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    if (formId && version) {
      getStudyLevelFormFieldsByVersion()
    }
  }, [formId, version]);

  useEffect(() => {
    if (eventId) {
      getSchemaEventForms()
    }
  }, [eventId, timePointId]);

  useEffect(() => {
    if (checkData?.schemaId) {
      getEventBasedonSchema()
    }
    setCheckType(checkData?.type)
    if (checkData?.type === "global") {
      setFormId(checkData?.formId)
      getStudyLevelForm()
    } else {
      setFormMetadataList([])
    }
    setQuery(checkData?.query || [])
  }, [checkData]);

  const renderBadgeValue = (item) => {
    if (item.type !== "operator") return item.value;
    switch (item.value) {
      case "===": return "=";
      case "/": return "÷";
      case "||": return "OR";
      case "&&": return "AND";
      case "if": return "IF";
      case "then": return "THEN";
      case "else": return "ELSE";
      case "else if": return "ELSE IF";
      default: return item.value;
    }
  };
  
  return (
    <>
      <div className="p-2">
        <div className="d-flex justify-content-between">
          <div className="hstack gap-2 mb-2">
            <button
              className="updateProfile hstack"
              onClick={() => setToggle()}
            >
              <FaPlus className="me-1" style={{marginBottom: -1}} />Add Parameter
            </button>
            <button
              className="updateProfile hstack"
              onClick={() => setToggle2()}
            >
              <FaPlus className="me-1" style={{marginBottom: -1}} />Add Dynamic Value
            </button>
            <button
              className="updateProfile hstack"
              onClick={() => setToggle4()}
            >
              <FaPlus className="me-1" style={{marginBottom: -1}} />Add Custom Value
            </button>
            <button
              className="updateProfile hstack"
              onClick={() => setToggle6()}
            >
              <FaPlus className="me-1" style={{marginBottom: -1}} />Add Operator
            </button>
            <button
              className="updateProfile hstack"
              onClick={() => setToggle9()}
            >
              <FaPlus className="me-1" style={{marginBottom: -1}} />Add Function
            </button>
            <button
              disabled={query?.length === 0}
              className="updateProfile hstack"
              onClick={() => setToggle8()}
            >
              <FaBars className="me-1" style={{marginBottom: -1}} />Manage Query
            </button>
          </div>
          <div>
            <button
              onClick={updateGlobalCustomEditCheck}
              className="updateProfile"
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm"/> Saving...
                </div>
              ) : (
                "Save Query"
              )}
            </button>
          </div>
        </div>
      </div>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        style={{ height: "-webkit-fill-available" }}
      >
        <div className="hstack gap-2 flex-wrap p-2 pt-0">
          {(query || [])?.map(item => (
            item?.type === "parameter" ?
              <Badge className="br3 text-dark px-3 py-2 CP" title={`Version ${item?.version}`} bg="primary-subtle" onClick={() => { setToggle1(); setQueryId(item?.id) }}>{item.value}</Badge>
              : item?.type === "dynamicValue" ?
                <Badge className="br3 text-dark py-2 px-3 CP" title={`Version ${item?.version}`} bg="primary-subtle" onClick={() => { setToggle3(); setQueryId(item?.id) }}>{item.value}</Badge>
                : item?.type === "customValue" ?
                  <Badge className="br3 text-dark py-2 px-3 CP" bg="primary-subtle" onClick={() => { setToggle5(); setQueryId(item?.id); setCustomValue(item?.value) }}>{item.value}</Badge>
                    : item?.type === "operator" ?
                    <Badge className="br3 text-dark py-2 px-3 CP" bg="danger-subtle" onClick={() => { setToggle7(); setQueryId(item?.id); setOperator(item?.value) }}>
                    {renderBadgeValue(item)}
                    </Badge>
                      : item?.type === "function" &&
                      <Badge className="br3 text-dark py-2 px-3 CP" bg="purple-subtle" onClick={() => { setToggle10(); setQueryId(item?.id); setFunctions(item?.value) }}>
                        {item.value}
                      </Badge>
          ))}
        </div>
      </SplitPane>

      <AddQueryParameterModal
        Show={!toggle}
        Hide={setToggle}
        formMetadataList={formMetadataList}
        setFormMetadataList={setFormMetadataList}
        setFormCode={setFormCode}
        formCode={formCode}
        setFieldCode={setFieldCode}
        fieldCode={fieldCode}
        setVersion={setVersion}
        version={version}
        setMainVersion={setMainVersion}
        mainVersion={mainVersion}
        setFormId={setFormId}
        setFieldId={setFieldId}
        setFieldUnit={setFieldUnit}
        fieldUnit={fieldUnit}
        setMainFieldCode={setMainFieldCode}
        mainFieldCode={mainFieldCode}
        setCustomField={setCustomField}
        customField={customField}
        setCustomFieldData={setCustomFieldData}
        customFieldData={customFieldData}
        formId={formId}
        fieldId={fieldId}
        formFields={formFields}
        setFormFields={setFormFields}
        setQuery={setQuery}
        query={query}
        setCheckType={setCheckType}
        setEventName={setEventName}
        setEventId={setEventId}
        setTimePointLabel={setTimePointLabel}
        setTimePointId={setTimePointId}
        checkType={checkType}
        eventName={eventName}
        eventId={eventId}
        timePointLabel={timePointLabel}
        timePointId={timePointId}
        eventRows={eventRows}
      />
      <UpdateQueryParameterModal
        Show={!toggle1}
        Hide={setToggle1}
        formMetadataList={formMetadataList}
        setFormMetadataList={setFormMetadataList}
        setFormCode={setFormCode}
        formCode={formCode}
        setFieldCode={setFieldCode}
        fieldCode={fieldCode}
        setVersion={setVersion}
        version={version}
        setMainVersion={setMainVersion}
        mainVersion={mainVersion}
        setFormId={setFormId}
        setFieldId={setFieldId}
        setFieldUnit={setFieldUnit}
        fieldUnit={fieldUnit}
        setMainFieldCode={setMainFieldCode}
        mainFieldCode={mainFieldCode}
        setCustomField={setCustomField}
        customField={customField}
        setCustomFieldData={setCustomFieldData}
        customFieldData={customFieldData}
        formId={formId}
        fieldId={fieldId}
        formFields={formFields}
        setFormFields={setFormFields}
        setQuery={setQuery}
        query={query}
        setQueryId={setQueryId}
        queryId={queryId}
        setCheckType={setCheckType}
        setEventName={setEventName}
        setEventId={setEventId}
        setTimePointLabel={setTimePointLabel}
        setTimePointId={setTimePointId}
        checkType={checkType}
        eventName={eventName}
        eventId={eventId}
        timePointLabel={timePointLabel}
        timePointId={timePointId}
        eventRows={eventRows}
      />
      <AddQueryDynamicValueModal
        Show={!toggle2}
        Hide={setToggle2}
        formMetadataList={formMetadataList}
        setFormMetadataList={setFormMetadataList}
        setFormCode={setFormCode}
        formCode={formCode}
        setFieldCode={setFieldCode}
        fieldCode={fieldCode}
        setVersion={setVersion}
        version={version}
        setMainVersion={setMainVersion}
        mainVersion={mainVersion}
        setFormId={setFormId}
        setFieldId={setFieldId}
        setFieldUnit={setFieldUnit}
        fieldUnit={fieldUnit}
        setMainFieldCode={setMainFieldCode}
        mainFieldCode={mainFieldCode}
        setCustomField={setCustomField}
        customField={customField}
        setCustomFieldData={setCustomFieldData}
        customFieldData={customFieldData}
        formId={formId}
        fieldId={fieldId}
        formFields={formFields}
        setFormFields={setFormFields}
        setOptions={setOptions}
        options={options}
        setOptionValue={setOptionValue}
        optionValue={optionValue}
        setQuery={setQuery}
        query={query}
        setCheckType={setCheckType}
        setEventName={setEventName}
        setEventId={setEventId}
        setTimePointLabel={setTimePointLabel}
        setTimePointId={setTimePointId}
        checkType={checkType}
        eventName={eventName}
        eventId={eventId}
        timePointLabel={timePointLabel}
        timePointId={timePointId}
        eventRows={eventRows}
      />
      <UpdateQueryDynamicValueModal
        Show={!toggle3}
        Hide={setToggle3}
        formMetadataList={formMetadataList}
        setFormMetadataList={setFormMetadataList}
        setFormCode={setFormCode}
        formCode={formCode}
        setFieldCode={setFieldCode}
        fieldCode={fieldCode}
        setVersion={setVersion}
        version={version}
        setMainVersion={setMainVersion}
        mainVersion={mainVersion}
        setFieldUnit={setFieldUnit}
        fieldUnit={fieldUnit}
        setFormId={setFormId}
        setFieldId={setFieldId}
        setMainFieldCode={setMainFieldCode}
        mainFieldCode={mainFieldCode}
        setCustomField={setCustomField}
        customField={customField}
        setCustomFieldData={setCustomFieldData}
        customFieldData={customFieldData}
        formId={formId}
        fieldId={fieldId}
        formFields={formFields}
        setFormFields={setFormFields}
        setOptions={setOptions}
        options={options}
        setOptionValue={setOptionValue}
        optionValue={optionValue}
        setQuery={setQuery}
        query={query}
        setQueryId={setQueryId}
        queryId={queryId}
        setCheckType={setCheckType}
        setEventName={setEventName}
        setEventId={setEventId}
        setTimePointLabel={setTimePointLabel}
        setTimePointId={setTimePointId}
        checkType={checkType}
        eventName={eventName}
        eventId={eventId}
        timePointLabel={timePointLabel}
        timePointId={timePointId}
        eventRows={eventRows}
      />
      <AddQueryCustomValueModal
        Show={!toggle4}
        Hide={setToggle4}
        setCustomValue={setCustomValue}
        customValue={customValue}
        setCustomType={setCustomType}
        customType={customType}
        setValueId={setValueId}
        valueId={valueId}
        setQuery={setQuery}
        query={query}
      />
      <UpdateQueryCustomValueModal
        Show={!toggle5}
        Hide={setToggle5}
        setCustomValue={setCustomValue}
        customValue={customValue}
        setCustomType={setCustomType}
        customType={customType}
        setValueId={setValueId}
        valueId={valueId}
        setQuery={setQuery}
        query={query}
        setQueryId={setQueryId}
        queryId={queryId}
        getStudyLevelFormFieldsByVersion={getStudyLevelFormFieldsByVersion}
      />
      <AddQueryOperatorModal
        Show={!toggle6}
        Hide={setToggle6}
        setOperator={setOperator}
        operator={operator}
        setQuery={setQuery}
        query={query}
        miniOperator={miniOperator}
      />
      <UpdateQueryOperatorModal
        Show={!toggle7}
        Hide={setToggle7}
        setOperator={setOperator}
        operator={operator}
        setQuery={setQuery}
        query={query}
        setQueryId={setQueryId}
        queryId={queryId}
        miniOperator={miniOperator}
        getStudyLevelFormFieldsByVersion={getStudyLevelFormFieldsByVersion}
      />
      <AddQueryFunctionModal
        Show={!toggle9}
        Hide={setToggle9}
        setFunctions={setFunctions}
        functions={functions}
        setQuery={setQuery}
        query={query}
      />
      <UpdateQueryFunctionModal
        Show={!toggle10}
        Hide={setToggle10}
        setFunctions={setFunctions}
        functions={functions}
        setQuery={setQuery}
        query={query}
        setQueryId={setQueryId}
        queryId={queryId}
        getStudyLevelFormFieldsByVersion={getStudyLevelFormFieldsByVersion}
      />
      <ManageQuery
        Show={!toggle8}
        Hide={setToggle8}
        setQuery={setQuery}
        query={query}
        buttonLoader={buttonLoader}
        updateGlobalCustomEditCheck={updateGlobalCustomEditCheck}
      />
    </>
  );
};

export default CustomEditCheckQuery;
